import cn from 'classnames';
import { Row } from 'ui';
import { Column, type ColumnProperties } from './column';

type ColumnChildren = ColumnProperties['children'];
type ColumnOptions = Omit<ColumnProperties, 'children'>;

type P = {
  left: ColumnChildren;
  leftOptions?: ColumnOptions;
  right: ColumnChildren;
  rightOptions?: ColumnOptions;
};

const TwoColumnLayout = ({ left, leftOptions, right, rightOptions }: P) => (
  <Row className="two-column-layout">
    <Column
      {...leftOptions}
      className={cn('two-column-layout__column', 'two-column-layout__column--left', leftOptions?.className)}
      space={{ position: 'right', size: false, ...leftOptions?.space }}
    >
      {left}
    </Column>
    <Column
      widthMode="stretch"
      {...rightOptions}
      className={cn('two-column-layout__column', 'two-column-layout__column--right', rightOptions?.className)}
      space={{ position: 'left', size: true, ...rightOptions?.space }}
    >
      {right}
    </Column>
  </Row>
);

export default TwoColumnLayout;
